// Steps/SummaryStep.jsx
// Recap of everything the wizard set up (number purchased, receptionist
// provisioned + linked, or number-only), with a Done button that closes and
// fires wizard.handleDone (refresh hook for the launching screen).

import React from "react";
import PropTypes from "prop-types";
import { Card } from "reactstrap";

function Line({ ok, label, value }) {
  return (
    <div className="d-flex align-items-center justify-content-between py-2 border-bottom border-light">
      <span className="d-flex align-items-center text-dark fw-medium">
        <i
          className={`me-2 fs-5 ${
            ok ? "ri-checkbox-circle-fill text-success" : "ri-close-circle-line text-muted"
          }`}
        ></i>
        {label}
      </span>
      {value && <span className="fw-bold text-dark">{value}</span>}
    </div>
  );
}

Line.propTypes = {
  ok: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
};

export function SummaryStep({ wizard }) {
  const {
    entryMode,
    purchasedNumber,
    selectedNumber,
    wantsReceptionist,
    receptionistSaved,
    assistantProvisioned,
    twilioLinked,
    handleDone,
    goBack,
  } = wizard;

  const numberDone = !!(purchasedNumber || selectedNumber);
  const number = purchasedNumber || selectedNumber || "-";

  // Receptionist steps run in receptionist mode, or in number mode when upsold.
  const receptionistInFlow =
    entryMode === "receptionist" || wantsReceptionist === true;

  return (
    <div className="step-container">
      <div className="mb-4 pb-2 border-bottom">
        <h4 className="text-pastel-blue fw-bold mb-1">All set</h4>
        <p className="text-muted small mb-0">
          Here&apos;s what we configured for you.
        </p>
      </div>

      <Card className="border-0 shadow-sm rounded-4 bg-white p-4 mb-2">
        <Line ok={numberDone} label="Phone number purchased" value={number} />
        {receptionistInFlow && (
          <>
            <Line ok={receptionistSaved} label="Receptionist configured" />
            <Line ok={assistantProvisioned} label="Assistant provisioned" />
            <Line ok={twilioLinked} label="Number linked to receptionist" />
          </>
        )}
        {!receptionistInFlow && (
          <div className="text-muted small fst-italic pt-2">
            No AI receptionist was added. You can add one any time from the
            Virtual Receptionist settings.
          </div>
        )}
      </Card>

      <div className="d-flex align-items-center justify-content-between mt-4 pt-3 border-top">
        <button
          type="button"
          className="btn btn-light rounded-pill px-4 fw-semibold text-muted"
          onClick={goBack}
        >
          <i className="ri-arrow-left-line me-2"></i> Back
        </button>
        <button
          type="button"
          className="btn btn-primary rounded-pill px-4 fw-semibold"
          onClick={handleDone}
        >
          <i className="ri-check-line me-2"></i> Done
        </button>
      </div>
    </div>
  );
}

SummaryStep.propTypes = {
  wizard: PropTypes.object.isRequired,
};
